import type { ApiResponse } from 'apisauce';
import type { Api } from './api';
import { getGeneralApiProblem } from './api-problem';
import type * as Types from './api.types';
import { bookmarkedRequestTransformer, singleRequestTransformer } from "../transformers/request-transformer";
import { paginatedRequestTransformer } from "../transformers/request-transformer";
import { paginationTransformer } from '../transformers/pagination-transformer';

export class RequestApi{
    private api: Api;

    constructor(api: Api) {
        this.api = api;
    }

    async getRequest(clientId:number, requestId:number): Promise<Types.GetKiaRequestDetailsResult>{
        try{
            const response: ApiResponse<any> = await this.api.apisauce.get(
                `api/client-user/${clientId}/request/${requestId}`                
            );

            if(!response.ok){
                const problem = getGeneralApiProblem(response);
                if(problem) return problem;      
            }          
            return {kind:"ok", request: singleRequestTransformer(response) };

        }catch(e){
            return {kind: "bad-data"};
        }
    }

    async getRequests(endPoint:string, screenMode?:'home' | 'explore' | 'bookmarks' | 'search'): Promise<Types.GetKiaRequestResult>{        
        const response: ApiResponse<any> = await this.api.apisauce.get(endPoint);
    
        if(!response.ok){
          const problem = getGeneralApiProblem(response);
          if(problem) return problem;      
        }        
    
        console.log(response);
        return {kind:"ok", requests: screenMode === 'bookmarks' ? bookmarkedRequestTransformer(response) : paginatedRequestTransformer(response), pagination: paginationTransformer(response)};
    }

    async createRequest(userId:number, data:any):Promise<any>{
        const response: ApiResponse<any> = await this.api.apisauce.post(`api/request/${userId}`,data);

        if(!response.ok){
            const problem = getGeneralApiProblem(response);
            if(problem) return problem;
        }

        console.log(response);
        return {kind: "ok"};
    }
}